import { GridColDef } from '@mui/x-data-grid-premium'
import { ColumnsPromptType } from '@omnea-app/core/smart-table-filters/createSmartFilter'

type PromptColumn = ColumnsPromptType[number]

export function getPromptColumn(column: GridColDef): PromptColumn {
  return {
    field: column.field,
    name: column.headerName || '',
    possibleOperators: getOperators(column).join(', '),
    type: getColumnType(column),
  }
}

function getColumnType(column: GridColDef): PromptColumn['type'] {
  if (column.type === 'dateTime' || column.type === 'date') {
    return 'date'
  }
  if (column.type === 'number') {
    return 'number'
  }
  if (column.type === 'boolean') {
    return 'boolean'
  }
  return 'text'
}

function getOperators(column: GridColDef): string[] {
  if (column.type === 'dateTime' || column.type === 'date') {
    return ['is', 'after', 'before']
  }
  if (column.type === 'number') {
    return ['>', '=', '<']
  }
  if (column.type === 'boolean') {
    return ['is']
  }
  return ['contains']
}
